/** @flow */

import React from "react";
import { Provider } from "react-redux";
import I18n from "redux-i18n";
import { LayoutProvider } from "react-page-layout";
import loginActionCreators from "@modules/account/actionCreator";

import { translations } from "@translations";
import { LoginLayout, DashboardLayout, CommonLayout } from "@layouts";
import Router from "./routes";
import { isStaticPage } from "@selectors/index";

import "@src/styles/theme.style.scss";

const layouts = {
  public: LoginLayout,
  dashboard: DashboardLayout,
  common: CommonLayout,
};

type Props = $Exact<{
  store: Object,
  history: Object,
}>;

class App extends React.Component<Props> {
  componentDidMount() {
    // call profile me only for private page
    if (!isStaticPage()) {
      this.props.store.dispatch(loginActionCreators.CheckLogin());
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <LayoutProvider layouts={layouts}>
        <Provider store={this.props.store}>
          <I18n translations={translations} initialLang="en" fallbackLang="en" useReducer={false}>
            <Router history={this.props.history} />
          </I18n>
        </Provider>
      </LayoutProvider>
    );
  }
}

export default App;
